import React, { useState, useEffect } from 'react';
import { MessageCircle, Phone, X } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const FloatingContact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPhoneDialog, setShowPhoneDialog] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const branches = [
    { name: 'Firq Branch', phone: '+968 9178 0974', whatsapp: '96891780974' },
    { name: 'Al Khadra Branch', phone: '+968 7191 8242', whatsapp: '96871918242' },
  ];

  const handleWhatsAppClick = (number) => {
    window.open(`https://wa.me/${number}`, '_blank');
  };

  const handlePhoneCall = (phone) => {
    window.location.href = `tel:${phone.replace(/\s/g, '')}`;
  };

  return (
    <>
      {/* Floating Buttons */}
      <div
        className={`fixed bottom-6 right-6 z-40 flex flex-col space-y-3 transition-all duration-500 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
        }`}
      >
        {/* WhatsApp Button */}
        <Button
          onClick={() => handleWhatsAppClick('96891780974')}
          className="group w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BD5A] shadow-2xl hover:shadow-[#25D366]/50 transition-all duration-300 hover:scale-110 flex items-center justify-center"
          title="Chat on WhatsApp"
        >
          <MessageCircle className="h-6 w-6 text-white group-hover:rotate-12 transition-transform duration-300" />
        </Button>

        {/* Phone Button */}
        <Button
          onClick={() => setShowPhoneDialog(true)}
          className="group w-14 h-14 rounded-full bg-[#1E7B8C] hover:bg-[#176573] shadow-2xl hover:shadow-[#1E7B8C]/50 transition-all duration-300 hover:scale-110 flex items-center justify-center"
          title="Call Us"
        >
          <Phone className="h-6 w-6 text-white group-hover:rotate-12 transition-transform duration-300" />
        </Button>
      </div>

      {/* Phone Selection Dialog */}
      <Dialog open={showPhoneDialog} onOpenChange={setShowPhoneDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-[#1E7B8C]">Select Branch to Call</DialogTitle>
            <DialogDescription className="text-gray-600">
              Choose which branch you'd like to contact
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 mt-4">
            {branches.map((branch, index) => (
              <div
                key={index}
                className="border-2 border-gray-200 rounded-lg p-4 hover:border-[#1E7B8C] hover:bg-gray-50 transition-all duration-300 cursor-pointer group"
              >
                <h4 className="font-bold text-gray-900 mb-3 group-hover:text-[#1E7B8C] transition-colors">
                  {branch.name}
                </h4>
                
                <div className="flex flex-col space-y-2">
                  {/* Phone Call */}
                  <Button
                    onClick={() => {
                      handlePhoneCall(branch.phone);
                      setShowPhoneDialog(false);
                    }}
                    className="w-full bg-[#1E7B8C] hover:bg-[#176573] text-white font-semibold"
                  >
                    <Phone className="h-4 w-4 mr-2" />
                    Call: {branch.phone}
                  </Button>
                  
                  {/* WhatsApp */}
                  <Button
                    onClick={() => {
                      handleWhatsAppClick(branch.whatsapp);
                      setShowPhoneDialog(false);
                    }}
                    className="w-full bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold"
                  >
                    <MessageCircle className="h-4 w-4 mr-2" />
                    WhatsApp
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FloatingContact;